import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import type { CommitteeRow, CommitteeStatus } from "../types";

export type CommitteeStatusChangeMode = "activate" | "deactivate";

export function committeeStatusChangeMode(status: CommitteeStatus): CommitteeStatusChangeMode {
  return status === "ACTIVE" ? "deactivate" : "activate";
}

export type CommitteeStatusChangeDialogProps = {
  open: boolean;
  committee: CommitteeRow | null;
  mode: CommitteeStatusChangeMode;
  saving?: boolean;
  onClose(): void;
  onConfirm(): void;
};

export default function CommitteeStatusChangeDialog({
  open,
  committee,
  mode,
  saving = false,
  onClose,
  onConfirm
}: CommitteeStatusChangeDialogProps) {
  const isDeactivate = mode === "deactivate";
  const hasParticipations = (committee?.totalParticipantCount ?? 0) > 0;
  const committeeLabel = committee ? <strong>{committee.name}</strong> : "this committee";

  return (
    <Dialog
      open={open}
      headline={isDeactivate ? "Deactivate Committee?" : "Activate Committee?"}
      onClosed={onClose}
      actions={
        <>
          <Button variant="text" onClick={onClose} testId="committee-status-change-cancel" disabled={saving}>
            Cancel
          </Button>
          <Button
            variant="filled"
            onClick={onConfirm}
            disabled={!committee || saving}
            testId="committee-status-change-confirm"
          >
            {isDeactivate ? "Deactivate" : "Activate"}
          </Button>
        </>
      }
    >
      <p className="text-body-medium">
        {isDeactivate ? (
          <>
            This will mark {committeeLabel} as inactive in the national committee catalog.
            {hasParticipations &&
              " Historical participations will remain on the committee and can still be viewed from All Committees."}
          </>
        ) : (
          <>
            This will mark {committeeLabel} as active in the national committee catalog. The committee will appear on
            the Active Committees tab.
          </>
        )}
      </p>
    </Dialog>
  );
}
